import { render, staticRenderFns } from "./IllustrationHeader.vue?vue&type=template&id=3877e827&scoped=true&"
import script from "./IllustrationHeader.vue?vue&type=script&lang=js&"
export * from "./IllustrationHeader.vue?vue&type=script&lang=js&"
import style0 from "./IllustrationHeader.vue?vue&type=style&index=0&id=3877e827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877e827",
  null
  
)

export default component.exports